import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Globals} from '../../../global/global.model';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';


@Injectable()
export class FotoSociosServices {

	constructor(private http: HttpClient) { }

	saveFotoSocio(data:any){
		return this.http.post(Globals.BASE_URL_API_REST+'fotosocios.json',data);
	}

}